<template lang="pug">
.screen-hotspot-fullscreen.dont-unlock.col-span-edge(ref="elRef")
  .hsf-wrapper-hotspot.z-0.overflow-hidden.lg_h-screen.flex.items-center.justify-center
    screen-hotspot(:edit-path="editPath" :screen="screen")
    audio-marker(:name="`${screen.id}-instructions`" v-if="audioDoc && screen.instructions")
    .hsf-instructions.absolute.mt-2.top-0.px-6.z-100.mx-auto(
      :data-queue-audio="getAudioURL(`${screen.id}-instructions`)"
      v-if="screen.instructions"
    )
      uc-editable.italic.instructions(
        :class="screen.styles?.instructions"
        :editPath="`${editPath}.instructions`"
        :k="screen.id + '.instructions'"
        :text="screen.instructions"
        uc-word-italic=""
      )

  .hotspot-next.absolute.flex.flex-col.gap-5.left-0.top-0.w-full.h-full.items-center.justify-center.auto-alpha-0(
    :class="['bg-white/70 dark_bg-black/70', {'auto-alpha-1': showOverlayNextButton}]"
  )
    uc-preload-sfx(name="continue")
    uc-button.btn-lg.btn-primary.unlock.ripple(
      :class="content?.course['button-color-from-closest-primary'] ? '' : content?.course?.primary && `primary-${content?.course?.primary}`"
      data-sfx="continue"
      @click="close"
    )
      uc-text(
        :k="buttonText ? `${screen.id}.continue` : 'Next'"
        :key="1"
        :text="buttonText || 'Next'"
          )

</template>
<script setup lang="ts">
import { computed, inject, nextTick, ref, watchEffect } from 'vue';

import useSuspend from '../lib/useSuspend';
import useAudio from '../stores/useAudio';

const suspend = useSuspend();
const audioDoc = inject('audioDoc');
const { getAudioURL } = useAudio();
const props = defineProps<{ screen: Props; editPath: string }>();

const elRef = ref<HTMLElement | null>(null);
const showOverlayNextButton = ref(false);
const overlayShown = ref(false);

function showOverlayNext(show) {
  if (overlayShown.value) {
    return;
  }
  showOverlayNextButton.value = show;
}

function close() {
  showOverlayNext(false);
  overlayShown.value = true;
  const el = elRef.value;
  const slides = el?.closest('.slides');
  if (props.screen['auto-scroll'] && slides) {
    // Find the slides screen ID by getting the closest .screen element's ID
    const slidesScreen = slides?.closest('.screen') as HTMLElement;
    const slidesScreenId = slidesScreen?.id;

    const page = el?.closest('.page') as UcPageElement;
    if (slidesScreenId) {
      page?.unlockAndScroll(slidesScreenId);
    }
  } else {
    el?.closest('.scroller')?.scrollOne('next', { force: true });
  }
}

watchEffect(() => {
  if (suspend.completed[props.screen.id]) {
    showOverlayNext(true);
  } else {
    showOverlayNext(false);
  }
});
</script>
<style>
#app .screen--hotspot-fullscreen {
  .screen-grid {
    margin: 0;
  }

  /* .display-yaml {
    display: none;
  } */

  .display-yaml-wrapper {
    display: block;
    button {
      color: var(--color-gray-900) !important;
      background-color: white !important;
    }
  }

  .uc-hotspot {
    width: 100%;
    height: 100vh;
    display: block;

    /* flip the image for RTL layout - could cause mirroring issues (text, icons, numbers etc.) */
    @apply rtl_-scale-x-100;

    svg {
      width: 100px;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  /* hide the clickable svg targets on mobile layout */
  svg [data-class='targets'] {
    display: block !important;
  }
}
</style>
